import { useCallback } from 'react';

import { toaster } from '@/components/ui/toaster';

const useCustomToast = () => {
  const showToast = useCallback(
    (title: string, description: string, type: 'success' | 'error') => {
      toaster.create({
        title,
        description,
        type,
      });
    },
    [toaster]
  );

  return showToast;
};

export default useCustomToast;
